/**
 * Marker content for a geo item (pothole / manhole) shown on a map.
 *
 * The dot is the only in-flow, fixed-size element, so a center-anchored
 * `<Marker>` places the dot's CENTER on the coordinate. The label floats above
 * the dot out of normal flow, so it does not push the dot below the coordinate.
 *
 * This fixes CG-270, where the label sat above the dot inside a centered column,
 * which anchored the whole [label + dot] box on the coordinate and left the dot
 * hanging below it (visibly worse as the map zooms out).
 */
export function GeoItemMarkerDot({
  label,
  fill,
  stroke,
  labelFontSize,
  testId,
  dotSize = 20,
}: {
  label?: string;
  fill: string;
  stroke: string;
  labelFontSize?: string | number;
  testId?: string;
  /** SVG dot diameter in px (default 20). */
  dotSize?: number;
}) {
  return (
    <div data-testid={testId} style={{ position: 'relative', width: dotSize, height: dotSize }}>
      {label ? (
        <div
          style={{
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: 2,
            backgroundColor: 'white',
            padding: 2,
            borderRadius: 2,
            whiteSpace: 'nowrap',
            fontSize: labelFontSize,
          }}
        >
          {label}
        </div>
      ) : null}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={dotSize}
        height={dotSize}
        viewBox="0 0 24 24"
        strokeWidth={5}
        stroke={stroke}
        fill={fill}
        opacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ display: 'block' }}
      >
        <title>Map marker</title>
        <circle cx="12" cy="12" r="10" />
      </svg>
    </div>
  );
}
